import { render, staticRenderFns } from "./Steps3.vue?vue&type=template&id=18160b6a&"
import script from "./Steps3.vue?vue&type=script&lang=ts&"
export * from "./Steps3.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports